import { callMeAjax } from '../callMeAjax.build.js';
import { getTranslation } from '../../../js/utils.js';

"use strict";

// Reload the page on persisted event. (Fixes bfcache behavior since content is dynamic)
window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        location.reload();
    }
});

// TODO: make a class with pagination
// TODO: remove select2 and jquery from herey

function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}

function _classCallCheck(instance, Constructor) {
    if (!_instanceof(instance, Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) {
            descriptor.writable = true;
        }
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}

function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) {
        _defineProperties(Constructor.prototype, protoProps);
    }
    if (staticProps) {
        _defineProperties(Constructor, staticProps);
    }
    return Constructor;
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }
    return obj;
}

export const Pagination = /*#__PURE__*/function () {
    function Pagination(newOptions) {
        _classCallCheck(this, Pagination);

        _defineProperty(this, "_options", {
            display_list_page: true, //Option of display of list page (if false display only the current page)
            display_go_to: true, //Option of display of "goTo" input
            auto_scroll_top: false,
            display_nav: true, //Option of display of nav (prev and next button)
            rewrite_url: true, //Option of rewritting url on page, number items or filters change
            number_items_per_page: 24, //Option of number items per page by default
            size_list: 'full', //Option of type display of list page ('full' display all pages, 'mini' display like : 1 ... 4 5 6 ... 10)
            pagination_content_wrapper: 'pagination_content_wrapper', //Class of the element where the items are displayed
            pagination_wrapper: 'pagination_wrapper', //Class of the element where the pagination is displayed
            pagination_filters: 'pagination_filters', //Class of the element where the filters are displayed
            pagination_number_items_found: 'pagination_number_items_found', //Class of the element where the number items found is displayed
            choices_number_per_page: [6, 12, 24, 30, 48], //Option list options of number items to display per page
            call_back_return: null //Optionnal function to call when ajax request is done
        });

        _defineProperty(this, "_choices_number_per_page", [6, 12, 24, 30, 48]); //List options of number items to display per page

        _defineProperty(this, "_current_page", 1); //Page where you are in the pagination

        _defineProperty(this, "_auto_scroll_top", false); //Page where you are in the pagination

        _defineProperty(this, "_display_list_page", true); //Option of display of list page (if false display only the current page)

        _defineProperty(this, "_display_go_to", true); //Option of display of "goTo" input

        _defineProperty(this, "_display_nav", true); //Option of display of nav (prev and next button)

        _defineProperty(this, "_rewrite_url", true); //Option of rewritting url on page, number items or filters change

        _defineProperty(this, "_number_items_per_page", 24); //Option of number items per page by default

        _defineProperty(this, "_size_list", 'full'); //Option of type display of list page ('full' display all pages, 'mini' display like : 1 ... 4 5 6 ... 10)

        _defineProperty(this, "_page_url", ''); //Url of the page where the pagination is

        _defineProperty(this, "_pagination_content_wrapper", void 0); //Element where the items are displayed

        _defineProperty(this, "_pagination_wrapper", void 0); //Element where the pagination is displayed

        _defineProperty(this, "_pagination_filters", void 0); //Element where the filters are displayed

        _defineProperty(this, "_pagination_number_items_found", void 0); //Element where the number items found is displayed

        _defineProperty(this, "_ajax_url", ''); //Url of ajax request to get all items and construct pagination

        //Set options
        if (typeof newOptions !== 'undefined') {
            this.options = newOptions;
        } //Set all html elements for pagination

        this.getAllHtmlElements(); //Set url of the page where pagination is

        if (this.htmlWrapper[0].hasAttribute('data-pagination-page-url')) {
            this.pageUrl = this.htmlWrapper[0].getAttribute('data-pagination-page-url');
        } //Set parameters from url get if rewrite url is authorize

        if (this.authorizeRewriteUrl) {
            this.getParametersFromUrl();
        }

        this.pageClick = function(e) {
            e.preventDefault();
            if (e.target && e.target.classList.contains('page')) {
                var $page = e.target;
                if (!$page.classList.contains('current')) {
                    this.currentPage = $page.getAttribute('data-page');
                    this.fetchAjaxInformationPagination(true, true);
                }
            }
        }.bind(this);
    }

    _createClass(Pagination, [{
        key: "resetPagination",
        // Reset current page, number page and number items by page
        value: function resetPagination(keep_nb_items_page_select) {
            this.currentPage = 1;
            this.numberPages = 1;

            if (!keep_nb_items_page_select) {
                this.numberItemsPerPage = this.options['number_items_per_page'];
            }
        } // Get all html elements needed for pagination

    }, {
        key: "getAllHtmlElements",
        value: function getAllHtmlElements() {
            //Where the list of items will appear
            this.htmlContentWrapper = document.getElementsByClassName(this.options['pagination_content_wrapper']); //Where the pagination will be generate

            this.htmlWrapper = document.getElementsByClassName(this.options['pagination_wrapper']); //Where the filters will be

            this.htmlFiltersWrapper = document.getElementsByClassName(this.options['pagination_filters']); //Where the number items found will be display

            this.htmlNumberItemsFound = document.getElementsByClassName(this.options['pagination_number_items_found']);

            if (this.htmlWrapper.length > 0) {
                //Where to get pagination source
                this.ajaxUrl = this.htmlWrapper[0].getAttribute('data-pagination-ajax');
            }
        } //Generate list items when an ajax request is set
        //      content : list items in html

    }, {
        key: "generateContent",
        value: function generateContent(content) {
            //Decoding utf8 because encoding in php (see in php to know why)
            this.htmlContentWrapper[0].innerHTML = content;
        } //Create the pagination from the list of items
        //      max : count of all items for all pages
        //      current_page : page where the user want to go
        //      url : url for the pagination

    }, {
        key: "generatePagination",
        value: function generatePagination(max, url, keep_nb_items_page_select) {
            max = typeof max !== 'undefined' ? max : 0;
            url = typeof url !== 'undefined' ? url : '';
            keep_nb_items_page_select = typeof keep_nb_items_page_select !== 'undefined' ? keep_nb_items_page_select : true;
            var current_page = this.currentPage;
            var number_items_by_page = this.numberItemsPerPage;
            var choices_number_per_page = this.choicesNumberItemsByPage;
            var number_pages = Math.ceil(max / number_items_by_page);
            this.numberPages = number_pages;
            var html = '';

            if (current_page > number_pages) {
                current_page = number_pages;
                this.currentPage = current_page;
            }

            var prev_page = current_page - 1;
            var next_page = current_page + 1;
            var to = current_page * number_items_by_page;

            if (to > max) {
                to = max;
            }

            var from = number_items_by_page * (current_page - 1) + 1;
            var $pagination_parameters = document.getElementById('pagination_parameters');
            var change_number_items_per_page = false;

            if ($pagination_parameters !== null && $pagination_parameters.value !== '') {
                change_number_items_per_page = true;
            }

            html += "\n            <div class=\"list_pages\">\n                <div>\n                    <input type=\"hidden\" class=\"url_page\" value=\"".concat(url, "\">\n                    \n                    <select class=\"number_items_per_page\">");

            for (var i = 0; i < choices_number_per_page.length > 0; i++) {
                html += '<option value="' + choices_number_per_page[i] + '"' + ((keep_nb_items_page_select || change_number_items_per_page) && choices_number_per_page[i] === this.numberItemsPerPage ? ' selected' : '') + '>' + getTranslation('pagination', 'display_items_at_once').replace('{number}', choices_number_per_page[i]) + '</option>';
            }

            html += "    </select>\n                </div>\n                <div class=\"page_display_wrapper\">";

            if (this.displayNav) {
                if (current_page > 1) {
                    let prev_page_url = url.replace('{page_number}', prev_page);
                    html += '<a href="' + prev_page_url + '" class="pagination_btn prev far fa-chevron-left" title="' + getTranslation('pagination', 'previous_page') + '" data-no-swup></a>';
                } else {
                    html += '<span class="pagination_btn prev far fa-chevron-left disabled" title="' + getTranslation('pagination', 'previous_page') + '"></span>';
                }
            }

            html += '<span class="page_display">';

            if (this.displayListPage) {
                for (var _i = 1; _i <= number_pages; _i++) {
                    if (this.sizeList === 'full') {
                        if (_i === current_page) {
                            html += '<span class="page' + (_i === current_page ? ' current' : '') + '" data-page="' + _i + '">' + _i + '</span>';
                        } else if(_i === 1) {
                            html += '<a href="' + url.split('?')[0] + '" class="page' + (_i === current_page ? ' current' : '') + '" data-page="' + _i + '" data-no-swup>' + _i + '</a>';
                        } else {
                            html += '<a href="' + url.replace('{page_number}', _i) + '" class="page' + (_i === current_page ? ' current' : '') + '" data-page="' + _i + '" data-no-swup>' + _i + '</a>';
                        }        
                    } else if (this.sizeList === 'mini') {
                        if (_i === 1 || _i === number_pages || _i === current_page || _i === current_page - 1 || _i === current_page + 1) {
                            if (_i === current_page) {
                                html += '<span class="page' + (_i === current_page ? ' current' : '') + '" data-page="' + _i + '">' + _i + '</span>';
                            } else if(_i === 1) {
                                html += '<a href="' + url.split('?')[0] + '" class="page' + (_i === current_page ? ' current' : '') + '" data-page="' + _i + '" data-no-swup>' + _i + '</a>';
                            } else {
                                html += '<a href="' + url.replace('{page_number}', _i) + '" class="page' + (_i === current_page ? ' current' : '') + '" data-page="' + _i + '" data-no-swup>' + _i + '</a>';
                            }
                        } else if (_i === current_page - 2 || _i === current_page + 2) {
                            html += '<span class="etc_page">...</span>';
                        }
                    }
                }
            } else {
                html += '<span class="page current" data-page="' + current_page + '">' + current_page + '</span>';
            }

            html += "   </span>\n                    <span class=\"pager_total\">".concat(((from>0) ? from : 1), " - ").concat(to, " / ").concat(max, "</span>");

            if (this.displayNav) {
                if (next_page <= number_pages) {
                    let next_page_url = url.replace('{page_number}', next_page);
                    html += '<a href="' + next_page_url + '" class="pagination_btn next far fa-chevron-right" title="' + getTranslation('pagination', 'next_page') + '" data-no-swup></a>';
                } else {
                    html += '<span class="pagination_btn next far fa-chevron-right disabled" title="' + getTranslation('pagination', 'next_page') + '"></span>';
                }
            }

            if (this.displayGoTo) {
                html += '<input type="text" class="go_to" value="" />';
            }

            html += "\n                </div>\n            </div>";
            this.htmlWrapper[0].innerHTML = html; //Bind events

            this.addEventListenerPagination();
            this.updateNumberItemsFound(max);
        } //Update just the current page style without recreate everything in pagination
        //      $current_page_current_page_link : link in the pagination to the current page

    }, {
        key: "updatePagination",
        value: function updatePagination(max, url) {
            max = typeof max !== 'undefined' ? max : 0;
            url = typeof url !== 'undefined' ? url : '';
            var number_items_by_page = this.numberItemsPerPage;
            var current_page = this.currentPage;
            var number_pages = Math.ceil(max / number_items_by_page);
            this.numberPages = number_pages;

            if (current_page > number_pages) {
                current_page = number_pages;
                this.currentPage = current_page;
            } //Update offset of items


            var to = current_page * number_items_by_page;

            if (to > max) {
                to = max;
            }

            var from = number_items_by_page * (current_page - 1) + 1;
            var $pager_total = this.htmlWrapper[0].getElementsByClassName('pager_total')[0];
            $pager_total.innerHTML = ((from > 0) ? from : 1) + ' - ' + to + ' / ' + max; //Update css class to display the current page

            if (this.displayListPage) {
                var $current_page_link = this.htmlWrapper[0].querySelectorAll(".page[data-page='" + current_page + "']").item(0);
                this.htmlWrapper[0].getElementsByClassName('current')[0].classList.remove('current');
                $current_page_link.classList.add('current');
            } //Update css class for nav


            if (this.displayNav) {
                let prev_page = current_page - 1;
                let next_page = current_page + 1;
                let prev_page_url = url.replace('{page_number}', prev_page);
                let next_page_url = url.replace('{page_number}', next_page);
                let pageListWrapper = this.htmlWrapper[0].querySelector('.list_pages .page_display_wrapper');
                let prev = pageListWrapper.getElementsByClassName("prev")[0];
                let next = pageListWrapper.getElementsByClassName("next")[0];
                let aBtn = document.createElement('a');
                aBtn.classList.add('pagination_btn', 'far');
                aBtn.setAttribute('data-no-swup', true);
                let spanBtn = document.createElement('span');
                spanBtn.classList.add('pagination_btn', 'far', 'disabled');

                if (current_page === 1) {
                    let newPrev = spanBtn.cloneNode(true);
                    newPrev.classList.add('prev', 'fa-chevron-left');
                    newPrev.setAttribute('title', getTranslation('pagination', 'previous_page'));
                    prev.replaceWith(newPrev);
                    
                    let newNext = aBtn.cloneNode(true);
                    newNext.classList.add('next', 'fa-chevron-right');
                    newNext.setAttribute('title', getTranslation('pagination', 'next_page'));
                    newNext.href = next_page_url;
                    next.replaceWith(newNext);
                } else if (current_page === number_pages) {
                    let newPrev = aBtn.cloneNode(true);
                    newPrev.classList.add('prev', 'fa-chevron-left');
                    newPrev.setAttribute('title', getTranslation('pagination', 'previous_page'));
                    newPrev.href = prev_page_url;
                    prev.replaceWith(newPrev);

                    let newNext = spanBtn.cloneNode(true);
                    newNext.classList.add('next', 'fa-chevron-right');
                    newNext.setAttribute('title', getTranslation('pagination', 'next_page'));
                    next.replaceWith(newNext);
                } else {
                    let newPrev = spanBtn.cloneNode(true);
                    newPrev.classList.add('prev', 'fa-chevron-left');
                    newPrev.setAttribute('title', getTranslation('pagination', 'previous_page'));
                    prev.replaceWith(newPrev);

                    let newNext = spanBtn.cloneNode(true);
                    newNext.classList.add('next', 'fa-chevron-right');
                    newNext.setAttribute('title', getTranslation('pagination', 'next_page'));
                    next.replaceWith(newNext);
                }
            } //Update list pages to display if style is 'mini'


            if (this.displayListPage && this.sizeList === 'mini') {
                var html = '';

                for (var i = 1; i <= number_pages; i++) {
                    if (i === 1 || i === number_pages || i === current_page || i === current_page - 1 || i === current_page + 1) {
                        if (i === current_page) {
                            html += '<span class="page' + (i === current_page ? ' current' : '') + '" data-page="' + i + '">' + i + '</span>';
                        } else if(i === 1) {
                            html += '<a href="' + url.split('?')[0] + '" class="page' + (i === current_page ? ' current' : '') + '" data-page="' + i + '" data-no-swup>' + i + '</a>';
                        } else {
                            html += '<a href="' + url.replace('{page_number}', i) + '" class="page' + (i === current_page ? ' current' : '') + '" data-page="' + i + '" data-no-swup>' + i + '</a>';
                        }
                    } else if (i === current_page - 2 || i === current_page + 2) {
                        html += '<span class="etc_page">...</span>';
                    }
                }

                this.htmlWrapper[0].getElementsByClassName("page_display")[0].innerHTML = html;
            } //Clear goTo value
            if (this.displayNav) {
                var $this_pagination = this; // SELECT
                var $nav = this.htmlWrapper[0].getElementsByClassName("pagination_btn");
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;
                

                try {
                    var _loop = function _loop() {
                        var $link = _step.value;
                        $link.addEventListener("click", function () {
                            if ($link.classList.contains('prev')) {
                                $this_pagination.currentPage = $this_pagination.currentPage - 1;
                            } else if ($link.classList.contains('next')) {
                                $this_pagination.currentPage = $this_pagination.currentPage + 1;
                            }

                            $this_pagination.fetchAjaxInformationPagination(true);
                        });
                    };

                    for (var _iterator = $nav[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        _loop();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }



            if (this.displayGoTo) {
                this.htmlWrapper[0].getElementsByClassName("go_to").item(0).value = '';
            }
        } //Bind events of click, change on span, select and input for pagination

    }, {
        key: "addEventListenerPagination",
        value: function addEventListenerPagination() {
            var $this_pagination = this; // SELECT
            //JQUERY mandatory slick
            //TODO pour passer à un plugin utilisant javascript ou React dans le futur

            $('select.number_items_per_page').select2({
                dropdownParent: $('select.number_items_per_page').parent(),
                width: '100%',
                minimumResultsForSearch: Infinity,  // Hide the search input
                theme: '',
                // language: lang
            })
            .on('select2:open', function (e) {
                let $dropdown = $('.select2-dropdown');
                $dropdown.hide();
                setTimeout(function(){ $dropdown.slideDown(250); }, 10);
            })
            .on('change', function() {
                $this_pagination.numberItemsPerPage = $(this).val();
                $this_pagination.fetchAjaxInformationPagination();
            });

            if (this._auto_scroll_top) {
                var scroll_top = $('.' + this._options['pagination_content_wrapper']).offset().top;
                var nav = $('.nav').first();
                if (nav.length) {
                    scroll_top -= nav.outerHeight(true) + 50;
                }
                $('body').on('click', '.pagination_btn, .page_display .page', function (e) {
                    e.preventDefault();
                    $('html, body').animate({ scrollTop: scroll_top }, 800);
                });
            } else {
                $('body').on('click', '.pagination_btn, .page_display .page', function (e) {
                    e.preventDefault();
                });
            }

            if (this.displayListPage) {
                this.htmlWrapper[0].addEventListener('click', this.pageClick);
            }

            if (this.displayGoTo) {
                var $go_to = this.htmlWrapper[0].getElementsByClassName("go_to").item(0);
                $go_to.addEventListener("change", function () {
                    if ($this_pagination.currentPage !== parseInt(this.value)) {
                        $this_pagination.currentPage = this.value;
                        $this_pagination.fetchAjaxInformationPagination(true);
                    }
                });
            }

            if (this.displayNav) {
                var $nav = this.htmlWrapper[0].getElementsByClassName("pagination_btn");
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    var _loop = function _loop() {
                        var $link = _step.value;
                        $link.addEventListener("click", function () {
                            if ($link.classList.contains('prev')) {
                                $this_pagination.currentPage = $this_pagination.currentPage - 1;
                            } else if ($link.classList.contains('next')) {
                                $this_pagination.currentPage = $this_pagination.currentPage + 1;
                            }

                            $this_pagination.fetchAjaxInformationPagination(true);
                        });
                    };

                    for (var _iterator = $nav[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        _loop();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        } //Update the number items found

    }, {
        key: "updateNumberItemsFound",
        value: function updateNumberItemsFound(max) {
            max = typeof max !== 'undefined' ? max : 0;
            this.htmlNumberItemsFound[0].innerHTML = max;
        } //Create the pagination from the list of items
        //      max : count of all items for all pages
        //      current_page : page where the user want to go
        //      url : url for the pagination

    }, {
        key: "rewriteUrl",
        value: function rewriteUrl(url) {
            window.history.pushState(
                {
                    url: url,
                    random: Math.random(),
                    source: 'swup'
                },
                document.getElementsByTagName('title')[0].innerText,
                url
            );
        } // Get pagination parameters from get url

    }, {
        key: "getParametersFromUrl",
        value: function getParametersFromUrl() {
            //We check if there is already some get parameters in case the user come to this page from an external link
            var $pagination_parameters = document.getElementById('pagination_parameters');

            if ($pagination_parameters !== null && $pagination_parameters.value !== '') {
                var parameters_string = $pagination_parameters.value; //If more than on parameter

                if (parameters_string.indexOf("&")) {
                    var list_param = parameters_string.split('&');

                    for (var i = 0; i < list_param.length; i++) {
                        var info = list_param[i].split('=');

                        if (info[0] === 'page') {
                            if (parseInt(info[1]) < 1) {
                                info[1] = "1";
                            }

                            this.currentPage = info[1];
                        } else if (info[0] === 'number_items') {
                            this.numberItemsPerPage = info[1];
                        }
                    }
                } else {
                    var _info = parameters_string.split('=');

                    if (_info[0] === 'page') {
                        this.currentPage = _info[1];
                    } else if (_info[0] === 'number_items') {
                        this.numberItemsPerPage = _info[1];
                    }
                }
            }
        } // Ajax query for pagination

    }, {
        key: "fetchAjaxInformationPagination",
        value: function fetchAjaxInformationPagination(update, keep_nb_items_page_select, reset, callback) {
            update = typeof update !== 'undefined' ? update : false;
            keep_nb_items_page_select = typeof keep_nb_items_page_select !== 'undefined' ? keep_nb_items_page_select : true;
            reset = typeof reset !== 'undefined' ? reset : true;
            callback = typeof callback !== 'undefined' ? callback : null;

            if (!update && reset) {
                this.resetPagination(keep_nb_items_page_select);
            }

            var $this_pagination = this;
            var current_page_number = this.currentPage;
            var formData = new FormData();
            if ($('#reference_id').length) {
                var reference_id = document.getElementById('reference_id').value;
                formData.append('reference_id', reference_id); //Filters
            }

            /**
             * Foreach hidden_params, add to the formData
             * Examples of hidden_params : field_reference_name, section_reference_id, page_reference_id
             */
            let $hidden_params = document.getElementsByClassName('hidden_params');
            for (let i = 0; i < $hidden_params.length; i++) {
                let $params = $hidden_params[i];
                formData.append($params.getAttribute('name'), $params.value);
            } 

            var data_value = '';
            var filter_name = '';
            var filters_list = [];
            var $filter_values = [];
            var $filters = this.htmlFiltersWrapper[0].querySelectorAll('.filter_container:not(.sort) .filter_sub ul, .filter_container:not(.sort) .filter_sub select, .filter_container:not(.sort) .filter_sub input');
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = $filters[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var $filter = _step2.value;
                    filters_list = [];

                    if (_instanceof($filter, HTMLInputElement) || _instanceof($filter, HTMLSelectElement)) {
                        filter_name = $filter.getAttribute('name');
                        var filter_value = $filter.value;
                        let filter_type = $filter.getAttribute('type');

                        if(filter_type == 'checkbox' || filter_type == 'radio') {
                            if ($filter.checked) {
                                filters_list.push(filter_value);
                                if (filter_name.indexOf('[]') == -1) {
                                    formData.append('filters[' + filter_name + ']', filters_list);
                                } else {
                                    filter_name = filter_name.replace(/\[\]/g, "");
                                    formData.append('filters[' + filter_name + '][]', filters_list);
                                }
                            }
                        } else {
                            if (filter_value !== '' && filter_value !== 'all') {
                                filters_list.push(filter_value);
                            }
    
                            if (filters_list.length > 0) {
                                if (filter_name.indexOf('[]') == -1) {
                                    formData.append('filters[' + filter_name + ']', filters_list);
                                }
                                else {
                                    filter_name = filter_name.replace(/\[/g, "").replace(/\]/g, "");
                                    formData.append('filters[' + filter_name + '][]', filters_list);
                                }
                            }
                        }
                    } else {
                        filter_name = $filter.getAttribute('data-filter');
                        $filter_values = $filter.querySelectorAll('li.checked');
                        var _iteratorNormalCompletion4 = true;
                        var _didIteratorError4 = false;
                        var _iteratorError4 = undefined;

                        try {
                            for (var _iterator4 = $filter_values[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                var value = _step4.value;
                                data_value = value.getAttribute('data-value');

                                if (data_value !== '' && data_value !== 'all') {
                                    filters_list.push(data_value);
                                }
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                    _iterator4.return();
                                }
                            } finally {
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }

                        if (filters_list.length > 0) {
                            if (filter_name.indexOf('[]') == -1) {
                                formData.append('filters[' + filter_name + ']', filters_list);
                            } else {
                                filter_name = filter_name.replace(/\[/g, "").replace(/\]/g, "");
                                formData.append('filters[' + filter_name + '][]', filters_list);
                            }
                        }
                    }
                } //Sort

            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            var sort_name = '';
            var sorts_list = [];
            var $sort_values = [];
            var $sorts = this.htmlFiltersWrapper[0].querySelectorAll('.filter_container.sort .filter_sub ul, .filter_container.sort .filter_sub select');
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = $sorts[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var $sort = _step3.value;

                    if (_instanceof($sort, HTMLSelectElement)) {
                        sort_name = $sort.getAttribute('name');
                        var sort_value = $sort.getAttribute('value');

                        if (sort_value !== '' && sort_value !== 'all') {
                            formData.append('sort[' + filter_name + ']', sort_value);
                        }
                    } else {
                        sort_name = $sort.getAttribute('data-sort');
                        $sort_values = $sort.querySelectorAll('li.checked');
                        var _iteratorNormalCompletion5 = true;
                        var _didIteratorError5 = false;
                        var _iteratorError5 = undefined;

                        try {
                            for (var _iterator5 = $sort_values[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                var _value = _step5.value;
                                data_value = _value.getAttribute('data-value');

                                if (data_value !== '' && data_value !== 'all') {
                                    sorts_list.push(data_value);
                                }
                            }
                        } catch (err) {
                            _didIteratorError5 = true;
                            _iteratorError5 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                                    _iterator5.return();
                                }
                            } finally {
                                if (_didIteratorError5) {
                                    throw _iteratorError5;
                                }
                            }
                        }

                        if (sorts_list.length > 0) {
                            formData.append('sort[' + sort_name + ']', sorts_list);
                        }
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            formData.append('current_page', current_page_number);
            formData.append('number_items_per_page', $this_pagination.numberItemsPerPage);
            formData.append('action', this.htmlWrapper[0].getAttribute('data-pagination-action'));
            callMeAjax(this.ajaxUrl, formData).done(function (data) {
                //If page in url is more than max pages available we update it
                if (typeof data.updated_current_page !== 'undefined') {
                    $this_pagination.currentPage = data.updated_current_page;
                }

                $this_pagination.generateContent(data.html);

                if (update) {
                    $this_pagination.updatePagination(data.max, data.url);
                } else {
                    $this_pagination.generatePagination(data.max, data.url, keep_nb_items_page_select);
                }
            }).done(function (data) {
                //We check if there is already some get parameters in case the user come to this page from an external link
                //Delete get parameter input
                var $pagination_parameters = document.getElementById('pagination_parameters');

                if ($pagination_parameters !== null && $pagination_parameters.value !== '') {
                    $pagination_parameters.parentNode.removeChild($pagination_parameters);
                }

                if ($this_pagination.authorizeRewriteUrl) {
                    var rewrite_url = $this_pagination.htmlWrapper[0].getElementsByClassName('url_page')[0].value.replace('{page_number}', $this_pagination.currentPage);
                    $this_pagination.rewriteUrl(rewrite_url);
                }

                if ($this_pagination.options['call_back_return'] !== null) {
                    window[$this_pagination.options['call_back_return']](data);
                }
                if (callback !== null) {
                    window[callback](data);
                }

                $(window).trigger('resetDOM');
            });
        }
    }, {
        key: "options",
        get: function get() {
            return this._options;
        },
        set: function set(newOptions) {
            var options = {};

            for (var index in this._options) {
                //If there is a custom value for this option we set it in
                if (typeof newOptions[index] !== 'undefined') {
                    options[index] = newOptions[index];
                    this['_' + index] = newOptions[index];
                } else {
                    //In the other case we just take the default option
                    options[index] = this._options[index];
                    this['_' + index] = this._options[index];
                }
            }

            this._options = options;
        }
    }, {
        key: "choicesNumberItemsByPage",
        get: function get() {
            return this._choices_number_per_page;
        },
        set: function set(choices_number_per_page) {
            this._choices_number_per_page = choices_number_per_page;
        }
    }, {
        key: "displayListPage",
        get: function get() {
            return this._display_list_page;
        },
        set: function set(display_list_page) {
            this._display_list_page = display_list_page;
        }
    }, {
        key: "displayGoTo",
        get: function get() {
            return this._display_go_to;
        },
        set: function set(display_go_to) {
            this._display_go_to = display_go_to;
        }
    }, {
        key: "displayNav",
        get: function get() {
            return this._display_nav;
        },
        set: function set(display_nav) {
            this._display_nav = display_nav;
        }
    }, {
        key: "numberItemsPerPage",
        get: function get() {
            return this._number_items_per_page;
        },
        set: function set(number_items_per_page) {
            this._number_items_per_page = parseInt(number_items_per_page);
        }
    }, {
        key: "sizeList",
        get: function get() {
            return this._size_list;
        },
        set: function set(size_list) {
            this._size_list = size_list;
        }
    }, {
        key: "pageToGo",
        get: function get() {
            return this._pageToGo;
        },
        set: function set(pageToGo) {
            this._pageToGo = current_page(pageToGo);
        }
    }, {
        key: "currentPage",
        get: function get() {
            return this._current_page;
        },
        set: function set(current_page) {
            current_page = parseInt(current_page);

            if (current_page < 1) {
                current_page = 1;
            } else if (current_page > this.numberPages) {
                current_page = this.numberPages;
            }

            this._current_page = current_page;
        }
    }, {
        key: "numberPages",
        get: function get() {
            return this._number_pages;
        },
        set: function set(number_pages) {
            this._number_pages = parseInt(number_pages);
        }
    }, {
        key: "authorizeRewriteUrl",
        get: function get() {
            return this._rewrite_url;
        },
        set: function set(rewrite_url) {
            this._rewrite_url = rewrite_url;
        }
    }, {
        key: "pageUrl",
        get: function get() {
            return this._page_url;
        },
        set: function set(page_url) {
            this._page_url = page_url;
        }
    }, {
        key: "htmlContentWrapper",
        get: function get() {
            return this._pagination_content_wrapper;
        },
        set: function set($pagination_content_wrapper) {
            this._pagination_content_wrapper = $pagination_content_wrapper;
        }
    }, {
        key: "htmlWrapper",
        get: function get() {
            return this._pagination_wrapper;
        },
        set: function set($pagination_wrapper) {
            this._pagination_wrapper = $pagination_wrapper;
        }
    }, {
        key: "htmlFiltersWrapper",
        get: function get() {
            return this._pagination_filters;
        },
        set: function set($pagination_filters) {
            this._pagination_filters = $pagination_filters;
        }
    }, {
        key: "htmlNumberItemsFound",
        get: function get() {
            return this._pagination_number_items_found;
        },
        set: function set($pagination_number_items_found) {
            this._pagination_number_items_found = $pagination_number_items_found;
        }
    }, {
        key: "ajaxUrl",
        get: function get() {
            return this._ajax_url;
        },
        set: function set(ajax_url) {
            this._ajax_url = ajax_url;
        }
    }]);

    return Pagination;
}();